import React from 'react';
import {Button} from '@tickchak/react-share/app';
import * as css from './ProcessPopup.css';
import {FooterButtonsProps} from './ProcessPopup.types';
import {useTranslation} from 'react-i18next';
import useMobile from '../../hooks/useMobile';

function FooterButtons({buttons = [], dataCyName, onClick}: FooterButtonsProps): React.ReactElement | null {
    const {t} = useTranslation('global');
    const isMobile = useMobile();
    if(buttons.length === 0) return null;

    const leftButtons = buttons.filter(btn => btn.position === 'left');
    const rightButtons = buttons.filter(btn => btn.position === 'right');
    const allButtons = [...leftButtons, ...rightButtons];

    const renderButton = (btn: any, index: number, prefix: string) => (
        <Button
            key={`${prefix}-${index}`}
            onClick={() => onClick(btn, index)}
            variant={btn.className === 'white' ? 'neutral' : 'brand'}
            size="category"
            disabled={btn.disabled}
            data-cy={`${dataCyName}Button${prefix}${index}`}>
            {t(btn.text)}
        </Button>
    );

    return (
        <css.footer>
            {isMobile ? (
                <css.buttonGroup className="mobile">
                    {allButtons.filter(btn => btn.show).map((btn, index) => 
                        renderButton(btn, index, 'm')
                    )}
                </css.buttonGroup>
            ) : (
                <>
                    <css.buttonGroup>
                        {leftButtons.filter(btn => btn.show).map((btn, index) => 
                            renderButton(btn, index, 'Left')
                        )}
                    </css.buttonGroup>
                    <css.buttonGroup>
                        {rightButtons.filter(btn => btn.show).map((btn, index) => 
                            renderButton(btn, index, 'Right')
                        )}
                    </css.buttonGroup>
                </>
            )}
        </css.footer>
    );
}

export default FooterButtons;

